import { Box, Button, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { jewlr_t } from "helpers/application"

import {
  LegalCopy,
  PlanSubtitle,
  PlanDesc,
  PlanDivider,
  PlanProductImage,
} from "./component"

const KlarnaDetail = ({ paymentPrices }) => {
  const klarnaAppLink = () =>
    `https://www.klarna.com/${sl.config.site_country}/klarna-app/`

  const customerServiceLink = () =>
    `https://www.klarna.com/${sl.config.site_country}/customer-service/`
  return (
    <>
      <PlanSubtitle>Pay in 4</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Split your purchase into 4 equal payments{" "}
        <span className="nowrap">
          on orders over {paymentPrices.klarnaMin}.
        </span>
      </PlanDesc>
      <PlanProductImage
        alt="double heart gemstone ring"
        ratio="208 / 105"
        srcSet={`${require("images/info/payment_plans/goldring.jpg")} 432w, ${require("images/info/payment_plans/goldring-x2.jpg")} 864w`}
      />
      <PlanSubtitle fontWeight="400">
        Double Heart Gemstone Ring with Accents:
      </PlanSubtitle>
      <PlanDesc fontWeight="300">
        {paymentPrices.splitPay} | 4 payments of {paymentPrices.splitPayRate}.
      </PlanDesc>
      <PlanDivider />
      <PlanSubtitle>Flexible Financing</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Pay over time with manageable monthly payments on orders over{" "}
        {paymentPrices.klarnaOrderMin}.
      </PlanDesc>
      <PlanProductImage
        alt="classic solitarie engagement ring"
        ratio="208 / 105"
        srcSet={`${require("images/info/payment_plans/jlux-ring.jpg")} 216w, ${require("images/info/payment_plans/jlux-ring-2x.jpg")} 432w`}
      />
      <PlanSubtitle mb={0}>
        Classic Solitaire Engagement Ring:
        <br />
        {paymentPrices.simpleFinancing} | {paymentPrices.klarnaFinancingRate}
        /month
      </PlanSubtitle>
      <PlanDesc fontSize="14px" fontWeight="300">
        for 6 months at 0% APR. Rates from 0–19.99% APR**
      </PlanDesc>
      <PlanDivider />
      <PlanSubtitle>How It Works</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Get flexible payment options to pay for your {jewlr_t("jewelry")} over
        time when you choose Klarna at checkout.
      </PlanDesc>
      <Box mb="13px">
        <PlanSubtitle mb={1}>1. Shop For {jewlr_t("Jewelry")}</PlanSubtitle>
        <PlanDesc fontWeight="300">
          {jewlr_t("Personalize")} your favorite styles and add them to your
          {jewlr_t("cart")}.
        </PlanDesc>
      </Box>
      <Box mb="13px">
        <PlanSubtitle mb={1}>2. Choose Klarna</PlanSubtitle>
        <PlanDesc fontWeight="300">
          If your order qualifies, select Klarna and provide your information.
        </PlanDesc>
      </Box>
      <Box mb="13px">
        <PlanSubtitle mb={1}>3. Complete Order</PlanSubtitle>
        <PlanDesc fontWeight="300">
          Once complete, Klarna will send an email confirmation and installment
          payment notice.
        </PlanDesc>
      </Box>
      <Box mb="13px">
        <PlanSubtitle mb={1}>4. Pay Over Time</PlanSubtitle>
        <PlanDesc fontWeight="300">
          Get more time with manageable payment options; first payment is due at
          time of purchase.
        </PlanDesc>
      </Box>
      <Image
        alt=""
        lazyload={false}
        maxWidth="253px"
        src={require(
          `images/info/payment_plans/klarna-${sl.config.site_country}.png`
        )}
      />
      <PlanSubtitle mb={6}>
        Questions?{" "}
        <Button
          as={Link}
          color="link"
          data-lc="klarna-detail"
          to="/helpdesk/search?query=Klarna"
          underline
          variant="text"
        >
          Check out our FAQs!
        </Button>
      </PlanSubtitle>
      <PlanDivider />
      <LegalCopy>
        ** You must be 18+ to use Klarna credit offers. Monthly financing
        through Klarna issued by WebBank, member FDIC. Promotional purchase rate
        ranges from 0%-19.99% APR. Non-promotional balances have an APR of
        19.99%. Subject to a $2 monthly minimum interest charge and credit
        approval. APR based on creditworthiness and subject to credit approval.
        Available on purchases between $149 and $10,000. See financing complete{" "}
        <a
          href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/account-terms?_ga=2.150214453.2019989092.1580223820-2095757696.1574237298"
          rel="noopener noreferrer"
          target="_blank"
        >
          terms
        </a>
        . Pay in 4 available on purchases between $35 and $2,500; a higher
        initial payment may be required for some consumers. See Pay in 4
        complete{" "}
        <a
          href="https://cdn.klarna.com/1.0/shared/content/legal/terms/0/en_us/sliceitinx"
          rel="noopener noreferrer"
          target="_blank"
        >
          terms
        </a>
        . Other CA resident loans made or arranged pursuant to a California
        Financing Law license. Please note that Klarna is an independent payment
        company and Jewlr has no influence over whether payments are accepted or
        not. Visit Klarna’s website{" "}
        <a
          href={customerServiceLink()}
          rel="noopener noreferrer"
          target="_blank"
        >
          here
        </a>{" "}
        or{" "}
        <a href={klarnaAppLink()} rel="noopener noreferrer" target="_blank">
          download the app
        </a>{" "}
        to speak with customer service
      </LegalCopy>
    </>
  )
}

KlarnaDetail.propTypes = {
  paymentPrices: PropTypes.object,
}

export default KlarnaDetail
